import { render, staticRenderFns } from "./PlanBase.vue?vue&type=template&id=c8e8d19a&"
import script from "./PlanBase.vue?vue&type=script&lang=js&"
export * from "./PlanBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports